import React from 'react';

function NoMatch() {
  return (
    <div>页面不存在，你输错地址了吧</div>
  );
}

export default NoMatch;